import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from '../../../../../app/shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';
import { DistribuicaoMensalMunicipioModelView, DistribuicaoMensalMunicipioFiltro, DadosOnInitModelView } from './../model/distribuicaoMensalMunicipio.model';
import { ExportTypes } from '../../../../shared/enum/TypeExportReportEnums';

@Injectable()
export class DistribuicaoMensalMunicipioService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {  }

  public dadosOnInitFormulario(): Observable<DadosOnInitModelView> {

    let retorno: Observable<DadosOnInitModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/consulta/DistribuicaoMensalDosMunicipios/DadosOnInitFormulario'), null);

    return retorno;
  }

  public consultarDistribuicaoMensalMunicipio(filtro: DistribuicaoMensalMunicipioFiltro): Observable<DistribuicaoMensalMunicipioModelView> {

    let retorno: Observable<DistribuicaoMensalMunicipioModelView> = null;

    retorno = this.http.post(this.baseConfig.getBaseUrlApi().concat('/consulta/DistribuicaoMensalDosMunicipios/ConsultarDistribuicao'), filtro);

    return retorno;
  }

  public  gerarRelatorioDistribuicaoMensal(filtro: DistribuicaoMensalMunicipioFiltro,
    tipoRel: ExportTypes): Observable<Blob>{
    const url = this.baseConfig.getBaseUrlApi().concat('/consulta/DistribuicaoMensalDosMunicipios/GerarRelatorioDistrubuicaoMensal');
    return this.http.report(url, filtro,tipoRel);
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/distribuicao-mensal-aos-municipio/shared/service/distribuicaoMensalMunicipio.service.ts